export default __webpack_public_path__ + "static/media/CaretLeft.7cb8227d.svg";